import { useGateValue } from "@statsig/react-bindings";

import { useFeatureFlag } from "@/features/featureFlag";

/**
 * Returns `true` if either the local feature flag
 * ("enable-openapi-v2-ip-allowlist") or the Statsig feature gate
 * ("enable_openapi_v2_ip_allowlist") is enabled. The local flag is the
 * override the team can flip without touching Statsig; the gate drives the
 * tiered rollout.
 */
export const useEnableOpenApiV2IpAllowlist = (): boolean => {
  const featureFlag = useFeatureFlag("enable-openapi-v2-ip-allowlist");
  const featureGate = useGateValue("enable_openapi_v2_ip_allowlist");
  return featureFlag || featureGate;
};
